<template>
  <div class="page-container">
    <el-breadcrumb separator="/" class="page-breadcrumb">
      <el-breadcrumb-item> APP设置 </el-breadcrumb-item>
    </el-breadcrumb>

    <el-card shadow="never" class="page-content">
      <div class="page-actions">
        <Add @refresh="refreshlist"></Add>
        <el-select v-model="platform">
          <el-option value="" label="全部"></el-option>
          <el-option
            v-for="item in platformType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select v-model="tenantId">
          <el-option value="" label="全部"></el-option>
          <el-option
            v-for="item in tentIdlist"
            :key="item.id"
            :label="item.tenantName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </div>
      <List @refresh="refreshlist"></List>
    </el-card>
  </div>
</template>

<script>
import './store'
import { mapState, mapActions } from 'vuex'
import List from './components/list'
import Add from './components/add'

export default {
  name: 'AppSetting',
  data() {
    return {
      platform: '',
      tenantId: '',
      platformType: [
        {
          value: 'android',
          label: 'android',
        },
        {
          value: 'ios_testflight',
          label: 'ios_testflight',
        },
        {
          value: 'ios_appstore',
          label: 'ios_appstore',
        },
        {
          value: 'google',
          label: 'google',
        },
      ],
    }
  },
  components: {
    List,
    Add,
  },
  computed: {
    ...mapState('app', ['pagination', 'tentIdlist']),
  },
  methods: {
    ...mapActions('app', ['getAppList', 'addApp', 'getTentIdlist']),
    refreshlist(data) {
      console.log('dataaaaaaaaaaaaaa', data)
      this.getAppList({
        ...this.pagination,
        ...data,
        platform: this.platform,
        tenantId: this.tenantId,
      })
    },
    handleSearch() {
      this.getAppList({
        ...this.pagination,
        platform: this.platform,
        tenantId: this.tenantId,
      })
    },
  },
  mounted() {
    // this.addApp({
    //   platform: 'android',
    //   isForce:true,
    //   uploadUrl:'http://android-ios.tset',
    //   content:'ios-android',
    //   version:'1.0.3',
    //   url:[{name:'android测试',url:'http://android-ios.tx'},{name:'android测试2',url:'http://android.test'}]
    // })
    this.getAppList({
      ...this.pagination,
      platform: this.platform,
      tenantId: this.tenantId,
    })
    this.getTentIdlist()
    // .then(res=>{
    //   if(res.code==0){
    //     this.getAppList()
    //   }
    // })
  },
}
</script>

<style lang="less" scoped></style>
